<template>
	<div class="list-document-item-common-actions">
		<o-icon
			v-if="actions.includes('visualize')"
			v-tooltip="entity.hasBeenVisualized
				? `${$t('common.view.details')} ${entity.document?.viewedDate?.toReadableDate()}`
				: $t('common.view.details')"
			font-icon="icon-interface-edit-view"
			:ripple="entity.hasBeenVisualized ? 'success' : 'info'"
			:class="{ 'text--success': entity.hasBeenVisualized }"
			@click.stop="entity.visualizeAsync()"/>

		<o-icon
			v-if="actions.includes('download')"
			v-tooltip="entity.hasBeenDownloaded
				? `${$t('business.attachments.download')} ${entity.document?.downloadedDate?.toReadableDate()}`
				: $t('admin.priority.download')"
			font-icon="icon-interface-download-button-2"
			:ripple="entity.hasBeenDownloaded ? 'success' : 'info'"
			:class="{ 'text--success': entity.hasBeenDownloaded }"
			@click.stop="entity.downloadAsync()"/>

		<slot/>

		<shared-tag-flat-select
			v-if="actions.includes('tag') && entity.tagLinks && setup.self.can('TagLink')"
			v-model="entity.tagLinks"
			v-model:opened="setup.tagSelectOpen"
			v-tooltip="$t('common.timeTicket.assignTag')"
			:link-ids="[entity.id]"
			:link-type="entity.tagLinkType"/>

		<o-icon
			v-if="actions.includes('select') && setup.isTouch"
			v-tooltip="$t('common.select.item')"
			icon="check"
			ripple="info"
			:class="{ 'text--info' : selected }"
			@click.stop="emits('select')"/>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedListDocumentItemActionsEmits, SharedListDocumentItemActionsProps } from './SharedListDocumentItemActionsSetup';
import SharedListDocumentItemActionsSetup from './SharedListDocumentItemActionsSetup';
const emits = defineEmits<SharedListDocumentItemActionsEmits>() as SharedListDocumentItemActionsEmits;
const props = withDefaults(defineProps<SharedListDocumentItemActionsProps>(), SharedListDocumentItemActionsSetup.defaultProps);
const setup = new SharedListDocumentItemActionsSetup(props, emits);
// #endregion
</script>

<style lang="less" scoped>
.list-document-item-common-actions {
	.ci-check {
		.arm-aside-top-actions & {
			display: none;
		}
	}
}
</style>
